import { useState, useEffect } from 'react';
import { useAppSelector } from '../redux/hook';

export function useGetApplicationUuid() {
  const [applicationId, setApplicationId] = useState<string | null>(null);
  const applicationUuid = useAppSelector((state) => state.app.ApplicationIdSlice.applicationId);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const idFromUrl = queryParameters.get('application_id');

    // Prefer the Redux UUID; fallback to URL
    setApplicationId(applicationUuid ?? idFromUrl);
  }, [applicationUuid]);

  return applicationId;
}
